import { Waypoint } from "vue-waypoint";

export default {
  name: "VenueTitle",
  props: {
    data: String,
    background: String,
  },
  components: {
    Waypoint,
  },
  created() {},
};
